import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.33333 17.5C5.11167 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.11167 2.5 8.33333 2.5M8.33333 17.5C11.555 17.5 14.1667 14.1421 14.1667 10C14.1667 5.85786 11.555 2.5 8.33333 2.5M8.33333 17.5H11.6667C14.8883 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.8883 2.5 11.6667 2.5H8.33333",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }